import Axios from 'axios';
import Qs from 'qs';

export default {

  // 抢单配置信息
  info() {
    return Axios.get('/wybx/api/admin/repair_config');
  },

  // 修改抢单配置
  edit(
    id,
    repair_config_value
  ) {
    return Axios.put(`/wybx/api/admin/repair_config/${id}`, {
      repair_config_value
    });
  },

}